export { default as ChildrenAge } from "./ChildrenAge";
export { default as NumberOfAdults } from "./NumberOfAdults";
export { default as NumberOfBabies } from "./NumberOfBabies";
export { default as NumberOfCats } from "./NumberOfCats";
export { default as NumberOfChildren } from "./NumberOfChildren";
export { default as NumberOfDogs } from "./NumberOfDogs";
export { default as NumberOfPets } from "./NumberOfPets";
export { default as NumberOfOtherPets } from "./NumberOfOtherPets";
